module.exports = __webpack_public_path__ + "static/media/scST.3c26d9be.png";